import { Breadcrumb, Col, Row, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import "./styles/index.less";
import { setting_url } from "../../services/setting";
import { useAuth } from "../../utils/Auth/AuthWrapper";

const { Title } = Typography;

type Props = {};

const ChatbotArena = (props: Props) => {
  const [url, setUrl] = useState<any>("");
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getData();
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getData = async () => {
    try {
      const res = await setting_url();
      setUrl(res.data[0].chatbot_arena_url);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="container-chatarena">
      <div>
        <Row justify="space-between" align="middle">
          <Col xs={24} md={24} lg={24} xl={24}>
            <Breadcrumb
                  separator=">"
                  items={[
                    {
                      title: (
                        <span style={{ fontWeight: "bold" }}>
                          Chatbot Arena
                        </span>
                      ),
                    },
                  ]}
                />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={24}>
          {isLoading ? (
          <Spin size="large" />
        ) : (
            <iframe
              key={"iframe"}
              src={
                url +
                `?uid=${user.user_id}&role=${user.role}&org=${user.org_name}`
              }
              width={"100%"}
              height={"600"}
              frameBorder="0"
            ></iframe>
          )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ChatbotArena;
